import styled, { css } from 'styled-components';
import { PRIMARY_200 } from '../../styles/colors';
import { isAmazonHost } from '../../utils';

export const ImageContainer = styled.div`
  position: relative;
  background-color: ${PRIMARY_200};

  img {
    max-height: 100%;
  }
`;

export const StepContent = styled.div`
  height: 100%;
`;

export const StepContentContainer = styled.div`
  overflow-y: scroll !important;

  ${() =>
    isAmazonHost() &&
    css`
      @media (max-width: 768px) {
        overflow-y: auto !important;
      }
    `}
`;
